
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 23L3 18.465v-3.953l5.4 3.122 3.1-3.406V23zm1-.001v-8.806l3.162 3.343L21 14.578v3.887l-8.5 4.534zM2.161 12.874L0 11.63l3-3.302-3-2.823L8.718 1l3.215 2.385L15.258 1 24 5.561l-2.995 2.771L24 11.775l-2.242 1.241v-.001l-5.903 3.27-3.348-3.541 7.416-3.962-7.922-4.372-7.923 4.372 7.422 3.937v.024l-3.297 3.622L3 13.357l-.16-.092-.679-.393v.002z"}})])
          )
        }
      }
    